import styled, { css } from 'styled-components';

const MosaicStyle = styled.section`
  width: 100%;

  > div {
    flex-direction: column;
  }

  h2 {
    display: flex;
    padding: 35px 0;
    color: #234757;
    font-size: 30px;
    align-items: center;
    background-image: url(https://emprendeoboticario.com.co/wp-content/themes/twentytwenty-child/images/acuarela_productos.png);
    background-repeat: no-repeat;
    background-size: cover;

    span {
      color: #107e78;
      font-size: 58px;
      font-family: 'FeltThatW01-Regular'
    }
  }

  @media(max-width: 800px) {
    h2 {
      padding: 25px;
    }
  }
`;

const ItemMosaic = styled.section`
  position: relative;

  div {
    display: none;
    position: absolute;
    align-items: flex-end;
    color: #fff;
    width: 100%;
    height: 100%;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    opacity: 0;

    h4 {
      font-family: 'FeltThatW01-Regular';
      font-size: 58px;
      line-height: 0.7;
      margin-bottom: 18px;
    }

    p {
      font-size: 16px;
      line-height: 1.25;
    }
  }

  &.active div {
    display: flex;
    opacity: 1;
    background-color:rgba(0, 0, 0, 0.8);
  }

  span {
    position: absolute;
    display: flex;
    height: 30px;
    left: 10px;
    bottom: 10px;
    font-size: 14px;
    line-height: 1.3;
    color: #273a46;
    background: #dde6eb;
    padding: 0 10px 0 0;
    border-radius: 30px;
    box-shadow: 0 8px 6px 0 rgb(0 0 0 / 16%);
    align-items: center;
    cursor: pointer;

    &:before {
      content: '+';
      width: 30px;
      height: 30px;
      color: #fff;
      font-size: 22px;
      letter-spacing: 8px;
      line-height: 1.4;
      margin-right: 7px;
      padding-left: 7px;
      border-radius: 100%;
      background: #93da49;
    }
  }
`;

const ColumnGroup = styled.section`
  display: flex;
  width: 100%;
  height: 625px;
  overflow: hidden;

  @media(max-width: 800px) {
    flex-direction: column;
    height: auto;
  }
`;

const ColumnMobile = css`
  @media(max-width: 800px) {
    width: 100%;
    height: auto;
    flex-direction: column;

    .item-1, .item-2, .item-3,
    .item-4, .item-5, .item-6 {
      width: 100%;
      height: 295px;
    }
  }
`;

const ColumnA = styled.section`
  display: flex;
  width: 58%;
  height: 625px;
  flex-wrap: wrap;

  .item-1 {
    width: 100%;
    height: 330px;
  }
  .item-2 {
    width: 47%;
  }
  .item-3 {
    width: 53%;
  }
  .item-2, .item-3 {
    height: 295px;
  }
  .item-1, .item-2, .item-3 {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  ${ColumnMobile}
`;

const ColumnB = styled.section`
  display: flex;
  width: 42%;
  height: 625px;
  flex-flow: column wrap;

  .item-4 {
    width: 50%;
    height: 625px;
  }
  .item-5 {
    height: 295px;
  }
  .item-6 {
    height: 330px;
  }
  .item-5, .item-6 {
    width: 50%;
  }
  .item-4, .item-5, .item-6 {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  ${ColumnMobile}
`;

export { MosaicStyle, ItemMosaic, ColumnGroup, ColumnA, ColumnB };
